import { createReducer, on } from '@ngrx/store';

import * as fromAuthLoginActions from '@apps/auth/store/login/login.actions';
import * as fromAuthProfileActions from '@apps/auth/store/profile/profile.actions';

import * as fromBckpActions from './bckp.actions';
import { BackBckpInitialState } from './bckp.state';

export const BackBckpReducer = createReducer(
    BackBckpInitialState,

    // Reset on logout / profile change
    on(
        fromAuthLoginActions.AuthLogout,
        fromAuthProfileActions.AuthProfileApplicationRolesSet,
        fromAuthProfileActions.AuthProfileApplicationRolesReset,
        () => BackBckpInitialState
    ),

    // Widget
    on(fromBckpActions.BackBckpWidgetRequested, (state) => ({
        ...state,
        widgetIsLoading: true,
        widgetIsLoaded: false,
        widgetIsOups: false
    })),
    on(fromBckpActions.BackBckpWidgetSucceeded, (state, { widget }) => ({
        ...state,
        widget,
        widgetIsLoading: false,
        widgetIsLoaded: true,
        widgetIsOups: false
    })),
    on(fromBckpActions.BackBckpWidgetFailed, (state) => ({
        ...state,
        widget: null,
        widgetIsLoading: false,
        widgetIsLoaded: false,
        widgetIsOups: true
    })),

    // Detail
    on(fromBckpActions.BackBckpDetailRequested, (state, { months }) => ({
        ...state,
        detailIsLoading: true,
        detailIsLoaded: false,
        detailIsOups: false,
        requestedMonths: months,
        entities: [],
        months: []
    })),
    on(fromBckpActions.BackBckpDetailSucceeded, (state, { entities, months }) => ({
        ...state,
        entities,
        months,
        detailIsLoading: false,
        detailIsLoaded: true,
        detailIsOups: false
    })),
    on(fromBckpActions.BackBckpDetailFailed, (state) => ({
        ...state,
        entities: [],
        months: [],
        detailIsLoading: false,
        detailIsLoaded: false,
        detailIsOups: true
    }))
);
